// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3CBJA","signatureButtonsRight":"ModalSign_signatureButtonsRight__3qATo"};